export default __webpack_public_path__ + "static/media/spt23.d361a189.jpg";